/**
 * AccoGift EasyGo Pet Outdoor Set 图片切换系统
 * 直接从 CDN 加载预渲染的组合图片
 * 命名规则: 
 * - 包图片: {BodyColor}__{HandleColor}__{LeashColor}.png
 * 注意：只显示包的图片，不显示牵引绳图片
 * 
 * 新策略：使用覆盖层而不是修改slider结构
 */

(function() {
  'use strict';

  console.log('🎒 [EasyGoOutdoorSet] 脚本开始加载...');

  // ========== 配置 ==========
  const PRODUCT_NAME = 'AccoGift EasyGo Pet Outdoor Set';
  const CDN_BASE_URL = 'https://cdn.shopify.com/s/files/1/0875/0733/7463/files/';
  const CDN_VERSION = '?v=1764284416';

  // EasyGo 颜色映射（包体、提手、牵引绳）
  const EASYGO_COLOR_MAP = {
    'Yellow': 'yellow',
    'Purple': 'purple',
    'White': 'white',
    'Black': 'black',
    'Pink': 'pink',
    'BabyBlue': 'babyblue',
    'Baby Blue': 'babyblue',
    'Blue': 'blue',
    'Cyan': 'cyan',
    'NavyBlue': 'navyblue',
    'Navy Blue': 'navyblue',
    'Navy': 'navyblue',
    'Orange': 'orange',
    'Green': 'green',
    'Red': 'red',
    'Brown': 'brown',
    'AccoYellow': 'accoyellow',
    'Acco Yellow': 'accoyellow'
  };

  // ========== 状态变量 ==========
  let updateTimer = null;
  let isUpdating = false;
  let lastUpdateKey = '';
  let overlayVisible = true; // 覆盖层是否显示
  let hasLoggedMismatch = false;
  let lastCheckedProduct = '';

  // ========== 工具函数 ==========

  function isCustomizePage() {
    return document.querySelector('.custom-builder') !== null;
  }

  function getProductType() {
    // 排除 Valentine 产品，避免误识别为包产品
    const url = window.location.href.toLowerCase();
    const pageTitle = document.title.toLowerCase();
    const path = window.location.pathname.toLowerCase();
    if (/valentine|情人节/.test(path + ' ' + pageTitle)) {
      return null;
    }

    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect && productSelect.options.length > 0) {
        const selectedOption = productSelect.options[productSelect.selectedIndex];
        if (selectedOption) {
          const selectedName = selectedOption.textContent.trim();
          const selectedHandle = (selectedOption.value || '').toLowerCase();
          if (selectedName.includes('AccoGift') && (selectedName.includes('EasyGo') || selectedName.includes('Outdoor Set') || selectedName.includes('Carrier') || selectedName.includes('Travel Set'))) {
            return 'accogift-easygo-set';
          }
          if (selectedHandle.includes('pet-travel-gift-set')) {
            return 'accogift-easygo-set';
          }
        }
      }
      return null;
    }

    if ((url.includes('accogift') && (url.includes('easygo') || url.includes('outdoor-set') || url.includes('carrier'))) ||
        (pageTitle.includes('accogift') && (pageTitle.includes('easygo') || pageTitle.includes('outdoor set') || pageTitle.includes('carrier')))) {
      return 'accogift-easygo-set';
    }
    // 🎯 SEO 改动：产品 handle 可能改为 pet-travel-gift-set（Customizable Pet Travel Gift Set）
    if (url.includes('pet-travel-gift-set') || pageTitle.includes('pet travel gift set') || pageTitle.includes('travel gift set')) {
      return 'accogift-easygo-set';
    }

    return null;
  }

  function shouldRun() {
    const productType = getProductType();
    if (productType === 'accogift-easygo-set') {
      if (!hasLoggedMismatch || lastCheckedProduct !== productType) {
        console.log(`✅ [EasyGoOutdoorSet] 产品类型: ${productType}`);
      }
      hasLoggedMismatch = false;
      lastCheckedProduct = productType;
      return true;
    }

    if (!hasLoggedMismatch || lastCheckedProduct !== productType) {
      console.log('⏭️ [EasyGoOutdoorSet] 不是 AccoGift EasyGo Pet Outdoor Set 产品');
      hasLoggedMismatch = true;
      lastCheckedProduct = productType || 'unknown';
    }
    return false;
  }

  function normalizeEasyGoColor(name) {
    if (!name) return null;
    if (EASYGO_COLOR_MAP[name]) return EASYGO_COLOR_MAP[name];
    
    const normalized = name.toLowerCase().replace(/\s+/g, '');
    
    for (const key in EASYGO_COLOR_MAP) {
      if (key.toLowerCase().replace(/\s+/g, '') === normalized) {
        return EASYGO_COLOR_MAP[key];
      }
    }
    
    console.warn('⚠️ [EasyGoOutdoorSet] EasyGo 颜色未映射:', name);
    return normalized;
  }

  function generateEasyGoCarrierImageUrl(bodyColor, handleColor, leashColor) {
    const normalizedBody = normalizeEasyGoColor(bodyColor);
    const normalizedHandle = normalizeEasyGoColor(handleColor);
    const normalizedLeash = normalizeEasyGoColor(leashColor);
    
    if (!normalizedBody || !normalizedHandle || !normalizedLeash) {
      console.warn('⚠️ [EasyGoOutdoorSet] EasyGo 包颜色信息不完整', { bodyColor, handleColor, leashColor });
      return null;
    }
    
    const filename = `${normalizedBody}__${normalizedHandle}__${normalizedLeash}.png`;
    const url = `${CDN_BASE_URL}${filename}${CDN_VERSION}`;
    
    console.log('🎒 [EasyGoOutdoorSet] 生成 EasyGo 包图片URL:', url);
    return url;
  }

  function getOptionValue(index) {
    if (isCustomizePage()) {
      if (typeof window.selectedOptions !== 'undefined' && window.selectedOptions && index < window.selectedOptions.length) {
        const value = window.selectedOptions[index];
        if (value) return value;
      }
      
      const swatch = document.querySelector(`.color-swatch[data-index="${index}"].selected`);
      if (swatch) return swatch.dataset.value;
      
      const textBtn = document.querySelector(`.text-option[data-index="${index}"].selected`);
      if (textBtn) return textBtn.dataset.value;
      
      const select = document.querySelector(`select[data-index="${index}"]`);
      if (select && select.value) return select.value;
      
      return null;
    } else {
      const globo = document.querySelector(`input[name="globo-option-${index}"]:checked`);
      if (globo) return globo.value;
      
      const idx = index + 1;
      const std = document.querySelector(`input[name*="option${idx}"]:checked, input[name*="Option${idx}"]:checked`);
      if (std) return std.value;
      
      const stdSelect = document.querySelector(`select[name*="option${idx}"], select[name*="Option${idx}"]`);
      if (stdSelect && stdSelect.value) return stdSelect.value;
    }
    return null;
  }

  // ========== 覆盖层管理 ==========

  /**
   * 获取或创建覆盖层容器
   */
  function getOrCreateOverlay() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return null;
    
    let overlay = mainImageContainer.querySelector('.easygo-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'easygo-overlay';
      overlay.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fff;
        z-index: 100;
        pointer-events: none;
      `;
      
      const img = document.createElement('img');
      img.className = 'easygo-overlay-image';
      img.style.cssText = `
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
      `;
      overlay.appendChild(img);
      
      // 确保 main-image 有相对定位
      mainImageContainer.style.position = 'relative';
      mainImageContainer.appendChild(overlay);
      
      console.log('✅ [EasyGoOutdoorSet] 创建覆盖层');
    }
    
    return overlay;
  }

  /**
   * 显示覆盖层
   */
  function showOverlay() {
    if (isCustomizePage()) return;
    
    const overlay = getOrCreateOverlay();
    if (overlay) {
      overlay.style.display = 'flex';
      overlay.style.visibility = 'visible';
      overlay.style.opacity = '1';
      overlayVisible = true;
      console.log('✅ [EasyGoOutdoorSet] 显示覆盖层');
    }
  }

  /**
   * 隐藏覆盖层
   */
  function hideOverlay() {
    if (isCustomizePage()) return;
    
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const overlay = mainImageContainer.querySelector('.easygo-overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.style.visibility = 'hidden';
      overlay.style.opacity = '0';
      overlayVisible = false;
      console.log('✅ [EasyGoOutdoorSet] 隐藏覆盖层');
    }
  }

  /**
   * 更新覆盖层图片
   */
  function updateOverlayImage(imageUrl) {
    const overlay = getOrCreateOverlay();
    if (!overlay) return;
    
    const img = overlay.querySelector('.easygo-overlay-image');
    if (!img) return;
    
    // 预加载图片
    const testImg = new Image();
    testImg.onload = function() {
      img.src = imageUrl;
      showOverlay();
      isUpdating = false;
      console.log('✅ [EasyGoOutdoorSet] 覆盖层图片已更新');
    };
    testImg.onerror = function() {
      console.error('❌ [EasyGoOutdoorSet] 覆盖层图片加载失败:', imageUrl);
      isUpdating = false;
    };
    testImg.src = imageUrl;
  }

  /**
   * 检查当前是否在第一个幻灯片
   */
  function isFirstSlideActive() {
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return false;
    
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    return firstSliderItem && firstSliderItem.classList.contains('is-active');
  }

  /**
   * 切换到第一个幻灯片
   */
  function switchToFirstSlide() {
    if (isCustomizePage()) return;
    
    const mainImageContainer = document.querySelector('.main-image');
    if (!mainImageContainer) return;
    
    const firstSliderItem = mainImageContainer.querySelector('.slider__item:first-child');
    if (!firstSliderItem || firstSliderItem.classList.contains('is-active')) {
      showOverlay();
      return;
    }
    
    // 使用 MediaGallery 的 setActiveMedia 方法
    const mediaGallery = document.querySelector('media-gallery');
    if (mediaGallery && firstSliderItem.dataset.mediaId) {
      if (typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(firstSliderItem.dataset.mediaId, true);
        console.log('✅ [EasyGoOutdoorSet] 已切换到第一个幻灯片');
        
        // 延迟显示覆盖层
        setTimeout(showOverlay, 100);
        return;
      }
    }
    
    // 备用方法：点击缩略图
    const firstThumbnail = document.querySelector('.thumbnails .slider__item:first-child .thumbnail');
    if (firstThumbnail) {
      firstThumbnail.click();
      setTimeout(showOverlay, 100);
    }
  }

  // ========== Customize 页面处理 ==========

  function updateCustomizePageImage(bodyColor, handleColor, leashColor) {
    console.log('🎒 [EasyGoOutdoorSet] 更新 Customize 页面图片');
    
    const carrierUrl = generateEasyGoCarrierImageUrl(bodyColor, handleColor, leashColor);
    if (!carrierUrl) {
      isUpdating = false;
      return;
    }
    
    const container = document.querySelector('.custom-builder .product-image');
    if (!container) {
      console.error('❌ [EasyGoOutdoorSet] 未找到 Customize 页面图片容器');
      isUpdating = false;
      return;
    }
    
    let imageContainer = container.querySelector('.easygo-single-image-container');
    let productImageLink = document.getElementById('product-link') || container.querySelector('.product-image-link');
    const mainImg = productImageLink ? productImageLink.querySelector('.main-image') : container.querySelector('.main-image');
    
    if (!imageContainer) {
      imageContainer = document.createElement('div');
      imageContainer.className = 'easygo-single-image-container';
      imageContainer.style.cssText = `
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        visibility: visible;
        opacity: 1;
        position: relative;
        z-index: 10;
        margin: 0;
        padding: 0;
      `;
      
      if (productImageLink) {
        productImageLink.style.cssText = 'display: none; visibility: hidden; position: absolute; left: -9999px;';
        container.insertBefore(imageContainer, container.firstChild);
      } else if (mainImg) {
        mainImg.style.display = 'none';
        container.insertBefore(imageContainer, container.firstChild);
      } else {
        container.insertBefore(imageContainer, container.firstChild);
      }
    }
    
    let carrierImg = imageContainer.querySelector('.easygo-carrier-image');
    if (!carrierImg) {
      carrierImg = document.createElement('img');
      carrierImg.className = 'easygo-carrier-image';
      carrierImg.style.cssText = `
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        display: block;
        visibility: visible;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      imageContainer.appendChild(carrierImg);
    }
    
    const testImg = new Image();
    testImg.onload = function() {
      carrierImg.src = carrierUrl;
      carrierImg.style.opacity = '1';
      isUpdating = false;
      console.log('✅ [EasyGoOutdoorSet] Customize 页面图片更新完成');
    };
    testImg.onerror = function() {
      console.error('❌ [EasyGoOutdoorSet] Customize 页面图片加载失败');
      isUpdating = false;
    };
    testImg.src = carrierUrl;
  }

  // ========== 主更新逻辑 ==========

  function doUpdateImage() {
    console.log('🎯 [EasyGoOutdoorSet] doUpdateImage() 被调用');
    
    if (!shouldRun()) return;
    
    if (isUpdating) {
      console.log('⏭️ [EasyGoOutdoorSet] 正在更新中，跳过');
      return;
    }
    
    const option0 = getOptionValue(0);
    const option1 = getOptionValue(1);
    const option2 = getOptionValue(2);
    
    const bodyColorOption = option1;
    const handleColorOption = option0;
    const leashColorOption = option2;
    
    console.log('🎒 [EasyGoOutdoorSet] 颜色选项:', { 包身: bodyColorOption, 把手: handleColorOption, 牵引绳: leashColorOption });
    
    const updateKey = `${bodyColorOption}_${handleColorOption}_${leashColorOption}`;
    if (updateKey === lastUpdateKey) {
      // 选项没变，但可能需要切换回第一个幻灯片
      if (!isCustomizePage() && !isFirstSlideActive()) {
        switchToFirstSlide();
      } else {
        showOverlay();
      }
      return;
    }
    
    if (!bodyColorOption || !handleColorOption || !leashColorOption) {
      console.warn('⚠️ [EasyGoOutdoorSet] 颜色选项不完整');
      return;
    }
    
    isUpdating = true;
    lastUpdateKey = updateKey;
    
    if (isCustomizePage()) {
      updateCustomizePageImage(bodyColorOption, handleColorOption, leashColorOption);
    } else {
      // 产品页面：先切换到第一个幻灯片，然后更新覆盖层
      switchToFirstSlide();
      
      const carrierUrl = generateEasyGoCarrierImageUrl(bodyColorOption, handleColorOption, leashColorOption);
      if (carrierUrl) {
        updateOverlayImage(carrierUrl);
      } else {
        isUpdating = false;
      }
    }
  }

  function updateImage() {
    if (updateTimer) {
      clearTimeout(updateTimer);
    }
    updateTimer = setTimeout(doUpdateImage, 300);
  }

  // ========== 事件处理 ==========

  function handleThumbnailClick(e) {
    if (!shouldRun()) return;
    if (isCustomizePage()) return;
    
    const thumbnail = e.target.closest('.thumbnail');
    if (!thumbnail) return;
    
    const sliderItem = thumbnail.closest('.slider__item');
    if (!sliderItem) return;
    
    // 检查是否点击的是第一个缩略图
    const thumbnailsList = document.querySelector('.thumbnails .slider__grid');
    if (!thumbnailsList) return;
    
    const allThumbnails = thumbnailsList.querySelectorAll('.slider__item');
    const clickedIndex = Array.from(allThumbnails).indexOf(sliderItem);
    
    console.log('🎒 [EasyGoOutdoorSet] 缩略图点击，索引:', clickedIndex);
    
    // 🎯 方案A：点击任何缩略图都隐藏覆盖层，显示原始图片
    // 只有选择选项时才显示拼图
    hideOverlay();
  }

  function handleCarouselSlide(e) {
    if (!shouldRun()) return;
    if (isCustomizePage()) return;
    
    const slideIndex = e.detail.index;
    console.log('🎒 [EasyGoOutdoorSet] 轮播滑动，索引:', slideIndex);
    
    // 🎯 方案A：手动滑动到任何幻灯片时隐藏覆盖层，显示原始图片
    // 只有选择选项时才显示拼图
    hideOverlay();
  }

  // ========== 初始化 ==========

  function init() {
    console.log('🎒 [EasyGoOutdoorSet] ========== 初始化开始 ==========');
    
    if (!shouldRun()) {
      console.log('⏭️ [EasyGoOutdoorSet] 初始化跳过');
      return;
    }
    
    console.log('✅ [EasyGoOutdoorSet] 确认为目标产品');
    console.log('   页面类型:', isCustomizePage() ? 'Customize页面' : '产品页面');
    
    if (!document.body.dataset.easygoOutdoorSetBound) {
      document.body.dataset.easygoOutdoorSetBound = 'true';
      
      // 选项点击事件
      document.body.addEventListener('click', function(e) {
        if (!shouldRun()) return;
        
        if (e.target.closest('.color-swatch') || 
            e.target.closest('.text-option') || 
            e.target.matches('input[type="radio"]') ||
            e.target.matches('label[for*="option"]')) {
          console.log('🎒 [EasyGoOutdoorSet] 检测到选项点击');
          updateImage();
        }
      }, true);
      
      // 选项变化事件
      document.body.addEventListener('change', function(e) {
        if (!shouldRun()) return;
        
        if (e.target.matches('select') || e.target.matches('input[type="radio"]')) {
          console.log('🎒 [EasyGoOutdoorSet] 检测到选项变化');
          updateImage();
        }
      }, true);
      
      // 缩略图点击事件
      if (!isCustomizePage()) {
        document.body.addEventListener('click', handleThumbnailClick, false);
        
        // 轮播滑动事件
        const section = document.querySelector('.js-product');
        if (section) {
          section.addEventListener('on:carousel-slider:select', handleCarouselSlide);
          
          // 🎯 关键：监听变体变化事件，在 MediaGallery 切换之后强制切换回第一个幻灯片
          section.addEventListener('on:variant:change', function(e) {
            if (!shouldRun()) return;
            
            console.log('🎒 [EasyGoOutdoorSet] 检测到变体变化事件');
            
            // 延迟执行，确保在 MediaGallery 的 onVariantChange 之后运行
            setTimeout(() => {
              console.log('🎒 [EasyGoOutdoorSet] 强制切换回第一个幻灯片');
              switchToFirstSlide();
              
              // 再次延迟显示覆盖层，确保切换完成
              setTimeout(showOverlay, 150);
            }, 200);
          });
          console.log('✅ [EasyGoOutdoorSet] 已绑定变体变化监听器');
        }
      }
      
      console.log('✅ [EasyGoOutdoorSet] 已绑定事件监听器');
    }
    
    // Customize 页面产品切换
    if (isCustomizePage()) {
      const productSelect = document.getElementById('product-select');
      if (productSelect) {
        productSelect.addEventListener('change', function() {
          hasLoggedMismatch = false;
          lastCheckedProduct = '';
          lastUpdateKey = '';
          setTimeout(() => {
            if (shouldRun()) {
              setTimeout(updateImage, 500);
            }
          }, 300);
        });
      }
    }
    
    // 初始更新
    setTimeout(updateImage, 1000);
    
    console.log('✅ [EasyGoOutdoorSet] 初始化完成');
  }

  window.EasyGoOutdoorSet = {
    update: updateImage,
    showOverlay: showOverlay,
    hideOverlay: hideOverlay,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 500);
  }

  console.log('🎒 [EasyGoOutdoorSet] 脚本加载完成');

})();
